export const FranchiseType = {
  franchisor: 'フランチャイズ',
  franchisee: '直営店',
} as const;
export type FranchiseType = keyof typeof FranchiseType;
